import api from './api';

export const getNotifications = async () => {
  const response = await api.get('/notifications/data');
  return response;
};

export const markNotificationsRead = async () => {
  const response = await api.post('/notifications/mark-read');
  return response;
};